import { render, staticRenderFns } from "./spareParts.vue?vue&type=template&id=27498312"
import script from "./spareParts.vue?vue&type=script&lang=js"
export * from "./spareParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27498312')) {
      api.createRecord('27498312', component.options)
    } else {
      api.reload('27498312', component.options)
    }
    module.hot.accept("./spareParts.vue?vue&type=template&id=27498312", function () {
      api.rerender('27498312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/inspection/spareParts.vue"
export default component.exports